import { t } from '@lingui/macro';
import { QRCodeSVG } from 'qrcode.react';

import { AppButton, TextInput, Version } from '@/UI';
import download from '@/assets/icons/document-download.svg';

import classes from './DownloadServerKeys.module.css';
import useDownloadServerKeys from './useDownloadServerKeys';

type Props = {};

const DownloadServerKeys = (props: Props) => {
    const { handleContinue, keys, handleDownload } = useDownloadServerKeys();
    return (
        <>
            <div className={classes['qr']}>
                <QRCodeSVG value={JSON.stringify(keys)} />
            </div>
            <div className={classes['inputWrapper']}>
                <TextInput
                    name="publicKey"
                    label={t`Public Key`}
                    icon={download}
                    isDisabled
                    defaultValue={keys?.publicKey && 'Public Key'}
                    onClick={handleDownload}
                />
                <TextInput
                    label={t`Private Key`}
                    name="privateKey"
                    isDisabled
                    icon={download}
                    defaultValue={keys?.privateKey && 'Private Key'}
                    onClick={handleDownload}
                />
            </div>
            <AppButton
                title={t`Continue`}
                onClick={handleContinue}
                classStyles={classes['appButton']}
            />
        </>
    );
};

export default DownloadServerKeys;
